import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE, DESC_ORDER } from "@duosoftbg/nacid-components";
import { ReferenceDataFilterDetails } from "../types/referenceDataTypes";

export const referenceDataFilterInitialValues: ReferenceDataFilterDetails = {
  domain: "",
  id: "",
  name: "",
  index: "",
  isActive: "",
  page: DEFAULT_PAGE,
  pageSize: DEFAULT_PAGE_SIZE,
  order: DESC_ORDER,
  orderBy: "domain",
};
